export function inputHelperPreventSpace(event) {
    if (event.key === " " || event.keyCode === 32) {
        event.preventDefault?.();
        return false;
    }

    return true;
}

export function inputHelperRemovePastedSpaces(event, element) {
    if (!isPasteEvent(event)) return true;

    const input = getInputElement(element);

    if (!input) return true;

    window.requestAnimationFrame(() => {
        removeSpaces(input);
        dispatchInputEvents(input);
    });

    return true;
}

function isPasteEvent(event) {
    return event?.type === "paste" || (event?.ctrlKey && event?.keyCode === 86);
}

function getInputElement(element) {
    if (element instanceof HTMLInputElement) return element;

    if (element?.jquery) {
        return element[0] instanceof HTMLInputElement ? element[0] : null;
    }

    return null;
}

function removeSpaces(input) {
    const value = input.value;
    const valueWithoutSpaces = value.replace(/\s/g, "");

    if (value !== valueWithoutSpaces) {
        input.value = valueWithoutSpaces;
    }
}

function parseDutchCurrency(value) {
    const raw = String(value || "")
        .trim()
        .replace(/\s/g, "");

    if (!raw) return null;

    const hasComma = raw.includes(",");
    const hasDot = raw.includes(".");

    if (hasComma) {
        const normalized = raw
            .replace(/\./g, "")
            .replace(",", ".");

        const parsed = Number(normalized);
        return Number.isFinite(parsed) ? parsed : null;
    }

    if (hasDot) {
        const parts = raw.split(".");

        if (parts.length === 2 && parts[1].length <= 2) {
            const parsed = Number(raw);
            return Number.isFinite(parsed) ? parsed : null;
        }

        const parsed = Number(raw.replace(/\./g, ""));
        return Number.isFinite(parsed) ? parsed : null;
    }

    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : null;
}

function formatDutchCurrency(value) {
    const parsed = parseDutchCurrency(value);

    if (parsed === null) return value;

    return new Intl.NumberFormat("nl-NL", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(parsed);
}

function formatInput(input) {
    const format = input.dataset.format;

    if (!format) return;

    if (format === "currency-euro") {
        input.value = formatDutchCurrency(input.value);
    }
}

function dispatchInputEvents(input) {
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));
}

export function initInputFormatters(root = document) {
    root.addEventListener(
        "keydown",
        (event) => {
            const input = event.target;

            if (!(input instanceof HTMLInputElement)) return;
            if (!input.matches("[data-prevent-space='true']")) return;

            inputHelperPreventSpace(event);
        },
        true
    );

    root.addEventListener(
        "paste",
        (event) => {
            const input = event.target;

            if (!(input instanceof HTMLInputElement)) return;
            if (!input.matches("[data-remove-pasted-spaces='true']")) return;

            inputHelperRemovePastedSpaces(event, input);
        },
        true
    );

    root.addEventListener(
        "blur",
        (event) => {
            const input = event.target;

            if (!(input instanceof HTMLInputElement)) return;
            if (!input.matches("[data-format]")) return;
            if (!input.value.trim()) return;

            const before = input.value;

            formatInput(input);

            if (input.value !== before) {
                dispatchInputEvents(input);
            }
        },
        true
    );
}